// @flow
import * as React from 'react';
import {ButtonLink} from 'sail/Button';
import Box from 'sail/Box';

type ElementsButtonLinkProps = {|
  label: string,
  href: string,
|};

export const ElementsButtonLink = ({label, href}: ElementsButtonLinkProps) => {
  return (
    <Box padding={{vertical: 20}}>
      <ButtonLink
        href={href}
        label={label}
        icon="next"
        iconPosition="right"
        color="blue"
        size="large"
        display="inline-flex"
      />
    </Box>
  );
};
